import { render } from "./DateTimeField.vue?vue&type=template&id=1219a139"
import script from "./DateTimeField.vue?vue&type=script&lang=js"
export * from "./DateTimeField.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DateTimeField.vue"]])

export default __exports__